import React, { useEffect } from 'react';
import { styled } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";

import Controls from '../../../components/Controls/videoRoom/Controls';
import LocalVideoPreview from '../../../components/LocalVideoPreview/LocalVideoPreview';
import MenuBar from '../../../components/MenuBar/MenuBar';
import ReconnectingNotification from '../../../components/ReconnectingNotification/ReconnectingNotification';
import Room from '../../../components/Room/videoRoom/Room';

import useRoomState from '../../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useAppState } from '../../../state';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const Main = styled('main')({
  height: '100%',
  position: 'relative',
});

export default function App(props: any) {
  const roomState = useRoomState();

  const { therapists, setting } = props;
  const { currentUser } = setting;
  const{ currentActiveCall } = therapists;
  const { connect } = useVideoContext();
  const { getVideoRoomToken, isFetching } = useAppState();
  
  useEffect(() => {

  if(currentActiveCall.callId){
    window.onbeforeunload = (e: any) =>{
      window.sessionStorage.removeItem('twilioTherapistToken');
      window.sessionStorage.setItem('therapistConnecting', "no");
    }
    const twilioToken = window.sessionStorage.getItem('twilioTherapistToken');
    const therapistConnecting = window.sessionStorage.getItem('therapistConnecting');
    
    if(therapistConnecting !== "yes"){
      if(twilioToken && twilioToken !== ""){
        connect(twilioToken, props);
        window.sessionStorage.setItem('therapistConnecting', "yes");
      }else if(!isFetching){
        let therapistName = currentActiveCall.therapistName.split(" ")[0] + (currentActiveCall.therapistName.split(" ")[1] ? currentActiveCall.therapistName.split(" ")[1] : "");
        
        getVideoRoomToken(therapistName + "_" + ((currentUser && currentUser.mobileNumber) ? currentUser.mobileNumber : ""), currentActiveCall.therapistRoom).then((token: any) => {
            window.sessionStorage.setItem('twilioTherapistToken', token);
            window.sessionStorage.setItem('therapistConnecting', "yes");
            connect(token, props);
          });
      }
    }
  }
  });
  return (
    <Container>
      <Main className={"main-room-container mt-0" + (isMobile ? " mobile-container" : "")}>
        {roomState === 'disconnected' ? <LocalVideoPreview /> : <Room {...props} currentUser={((currentUser && currentUser.mobileNumber) ? currentUser.mobileNumber : "")} showMute={true}/>}
        <Controls {...props}/>
      </Main>
      <ReconnectingNotification />
    </Container>
  );
}
